/* global rp$, window */
'use strict';

const { handleGarageData } = require('public/js/components/garage-store.js');
const utils = require('public/js/helpers/utils');

const clearGarageCache = () => {
	handleGarageData.clearGarageCache();
};

var THE_SCRIPT = function() {
	const $onReady = require('public/js/lib/on-ready');

	function removeCarFromGarage(evt) {
		evt.preventDefault();
		evt.stopPropagation();
		const target = evt.target;
		const closeIcon = target.closest('.car-close-icon');
		if (!closeIcon) {
			return;
		}
		const carHash = closeIcon.getAttribute('data-car-hash');
		if (!carHash) {
			return;
		}

		closeIcon.classList.add('loading');
		const icon = closeIcon.querySelector('i');
		const spinner = document.createElement('div');
		spinner.className = 'loading-spinner';
		if (icon) {
			icon.appendChild(spinner);
		}

		const currentFullPath = window.location.pathname;

		let alternativeCarHash = null;
		let alternativeCarPath = null;
		const currentListItem = closeIcon.closest('li');
		if (currentListItem && currentListItem.parentElement) {
			const siblingListItems = currentListItem.parentElement.querySelectorAll('li');

			for (let i = 0; i < siblingListItems.length; i++) {
				const siblingItem = siblingListItems[i];
				const otherCloseIcon = siblingItem.querySelector('.car-close-icon');

				if (!otherCloseIcon) continue;

				const otherCarHash = otherCloseIcon.getAttribute('data-car-hash');
				const otherDataPath = otherCloseIcon.getAttribute('data-path');

				if (otherCarHash !== carHash) {
					alternativeCarHash = otherCarHash;
					const otherMatch = otherDataPath.match(/^\/v-[^/]+/);
					const otherFirstPathSegment = otherMatch ? otherMatch[0] : otherDataPath;
					// No redirect on vehicle remove
					alternativeCarPath = otherFirstPathSegment;
					break;
				}
			}
		}

		const requestData = { carHash: carHash };
		if (alternativeCarHash) {
			requestData.alternativeCarHash = alternativeCarHash;
		}

		clearGarageCache();
		$ajax({
			url: '/ajax/garage/remove-car',
			type: 'POST',
			data: requestData,
			success: function(response) {
				if (typeof response === 'string' && response.includes('<!DOCTYPE html>')) {
					closeIcon.classList.remove('loading');
					const spinner = icon?.querySelector('.loading-spinner');
					if (spinner) {
						spinner.remove();
					}
					return;
				}

				if (response.success || response.status === 'success') {
					if (window.rp_app && window.rp_app.always_reload_on_vehicle_selection) {
						window.location.reload();
						return;
					}

					if (response.reload_page && response.alternative_selected) {
						window.location.reload();
						return;
					}

					const isVehicleSpecificPage = currentFullPath.match(/^\/v-[^/]+/) !== null;
					const isProductPage = currentFullPath.match(/^\/parts\//) !== null;

					if (isVehicleSpecificPage) {
						if (response.alternative_selected) {
							window.location.href = alternativeCarPath;
						} else {
							window.location.href = '/';
						}
					} else if (isProductPage) {
						window.location.reload();
					} else {
						if (response.alternative_selected) {
							const alternativeWithProducts = alternativeCarPath + '/products';
							window.location.href = alternativeWithProducts;
						} else {
							window.location.href = '/';
						}
					}
				} else {
					closeIcon.classList.remove('loading');
					const spinner = icon?.querySelector('.loading-spinner');
					if (spinner) {
						spinner.remove();
					}
				}
			},
			error: function() {
				closeIcon.classList.remove('loading');
				const spinner = icon ? icon.querySelector('.loading-spinner') : null;
				if (spinner) {
					spinner.remove();
				}
			}
		});
	}

	function selectCarFromGarage(evt) {
		// Don't intercept if clicking the close icon
		if (evt.target.closest('.car-close-icon')) {
			return;
		}

		const $link = rp$(evt.currentTarget);
		if (!$link.hasClass('recent-car')) {
			return;
		}

		// If always_reload_on_vehicle_selection is true, attempt to reload
		if (window.rp_app && window.rp_app.always_reload_on_vehicle_selection) {
			// Get vehicle data from data attributes
			const year = $link.data('year');
			const make = $link.data('make');
			const model = $link.data('model');
			const trim = $link.data('trim') || '';
			const engine = $link.data('engine') || '';

			// If data is missing, let the anchor tag navigate normally
			if (!year || !make || !model) {
				return;
			}

			// Prevent default anchor behavior since we're intercepting
			evt.preventDefault();
			evt.stopPropagation();

			const variables = {
				type: 'set_parts_model',
				product: 'auto',
				year: year,
				make: make,
				model: model
			};

			if (trim) {
				variables.trim = trim;
			}
			if (engine) {
				variables.engine = engine;
			}

			if (rp_app.env && rp_app.env.page) {
				variables.page = rp_app.env.page;
			}

			clearGarageCache();
			// Set the vehicle via AJAX, then reload instead of navigating to the URL
			$ajax({
				method: 'post',
				url: '/ajax/vehicle-picker/select',
				data: variables,
				dataType: 'json',
				success: function() {
					// Reload the page instead of redirecting
					window.location.reload();
				},
				error: function() {
					// On error, fall back to normal navigation (server-side will set the vehicle)
					// We've already prevented default, so we need to navigate manually
					window.location.href = $link.attr('href');
				}
			});
		} else {
			clearGarageCache();
		}
	}

	function handleGarageListItems(eventOrGarage, maybeGarage, ...rest) {
		const garage = utils.normalizeEventPayloadArgs(eventOrGarage, maybeGarage, rest);
		if (garage.length === 0) {
			return;
		}
		const containerComponents = document.querySelectorAll('.garage-list-items-container');
		if (!containerComponents.length) {
			return;
		}

		containerComponents.forEach((container) => {
			const templateContainer = container.nextElementSibling;
			if (!templateContainer?.classList?.contains('garage-list-items-template')) {
				return;
			}
			const template = templateContainer.querySelector('li');
			if (!template) {
				return;
			}
			container.innerHTML = '';

			const orderedGarage = garage
				.filter((car) => car && typeof car === 'object' && car.selected)
				.concat(garage.filter((car) => !car || typeof car !== 'object' || !car.selected));

			orderedGarage.forEach((car) => {
				const clone = template.cloneNode(true);
				clone.style.display = '';
				clone.classList.remove('garage-item-template');

				const link = clone.querySelector('.recent-car');
				const closeIcon = clone.querySelector('.car-close-icon');
				if (!link || !closeIcon) {
					return;
				}

				link.dataset.year = car.year;
				link.dataset.make = car.make;
				link.dataset.model = car.model;
				link.dataset.trim = car.trim || '';
				link.dataset.engine = car.engine || '';

				const icon = clone.querySelector('.car-first-icon');
				if (car.selected) {
					clone.classList.add('car-selected');
					icon.querySelector('span').style.display = '';
				} else {
					icon.querySelector('span').style.display = 'none';
				}

				let path = utils.buildVehicleBasePath(car);
				if (!path) 
					return;

				if (typeof link.dataset.browseSuffix === 'string' && link.dataset.browseSuffix !== '') {
					path += link.dataset.browseSuffix;
				}
				link.setAttribute('href', path);

				const label = clone.querySelector('.car-label');
				label.textContent = car.ui_short;
				closeIcon.dataset.carHash = car.hash;
				closeIcon.dataset.path = path;

				container.appendChild(clone);
			});
		});
	}

	function attachEvents() {
		if (!handleGarageData || typeof handleGarageData.getGarageData !== 'function') {
			return;
		}

		rp$(document)
			.off('garageUpdated.garageListItems')
			.on('garageUpdated.garageListItems', handleGarageListItems);

		const containerComponent = document.querySelector('.garage-list-items-container');
		const isVehicleSpecificPage = utils.isTruthyDataValue(containerComponent?.dataset?.isVehicleSpecificPage);
		const garage = handleGarageData.getGarageData(isVehicleSpecificPage);
		if (garage) {
			handleGarageListItems(garage);
		}
	}

	(function GarageComponent() {
		$onReady({
			rp$,
			window,
			label: 'garage_component',
			fn: function() {
				attachEvents();
				rp$('.garage.flyout').on('click', '.car-close-icon', removeCarFromGarage);
				rp$('.garage.flyout').on('click', '.recent-car', selectCarFromGarage);
				rp$('.garage.flyout').on('click', '.search-all-vehicles', clearGarageCache);
				rp$('.garage.flyout').on('click', '.clear-all-vehicles', clearGarageCache);
			}
		});
	})();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	if (typeof __CURRENT_SCRIPT__ === 'undefined') {
		throw new Error('__CURRENT_SCRIPT__ is not defined');
	}
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
